<br />

<div *ngIf="selectedQueue === null">
  <table class="table table-responsive-lg table-bordered">
    <thead class="thead-light">
      <tr>
        <th rowspan="2">File <div style="cursor: pointer;" title="Cliquer pour recharger"  (click)="listerQueues()">(Recharger)</div></th>
        <th colspan="2">Messages actifs</th>
        <th colspan="2">Messages en erreur</th>
      </tr>
      <tr>
        <th>A traiter</th>
        <th>En cours</th>
        <th>Visibles</th>
        <th>Invisibles</th>
      </tr>
    </thead>
    <tbody *ngIf="queues !== null">
      <tr *ngFor="let queue of queues">
        <td style="width:40%; ">
          {{ queue.name }}
        </td>
        <td [ngStyle]="queueStyleStandard(queue.activeAvailable)" style="width: 15%;">
          {{ queue.activeAvailable }}
        </td>
        <td [ngStyle]="queueStyleStandard(queue.activeProcessing)" style="width: 15%;">
          {{ queue.activeProcessing }}
        </td>
        <td [ngStyle]="queueStyleError(queue.errorAvailable)" (click)="selectQueue(queue)" style="width: 15%;">
          {{ queue.errorAvailable }}
        </td>
        <td [ngStyle]="queueStyleErrorInv(queue.errorInvisible)" style="width: 15%;">
          {{ queue.errorInvisible }}
        </td>
      </tr>
    </tbody>
  </table>
  <span *ngIf="queues !== null && queues.length === 0">Aucun r&eacute;sultat</span>
  <br/>
</div>

<div *ngIf="selectedQueue !== null">
  <table class="table table-responsive-lg table-bordered">
    <thead class="thead-light">
      <tr>
        <th colspan="3">File {{ selectedQueue.name }} <span style="cursor: pointer;" title="Cliquer pour revenir &agrave; la liste"  (click)="listerQueues()">(Retour)</span></th>
      </tr>
    </thead>
    <tbody *ngIf="messages !== null">
    <tr *ngFor="let message of messages">
      <td style="width: 80%;">
        {{ message.body }}
      </td>
      <td style="width: 10%;cursor: pointer;" (click)="moveMessage(message)">
        Recycler
      </td>
      <td style="width: 10%;cursor: pointer;" (click)="deleteMessage(message)">
        Supprimer
      </td>
    </tr>
    </tbody>
  </table>
  <span *ngIf="messages !== null && messages.length === 0">Aucun message</span>
  <br/>
</div>



// WEBPACK FOOTER //
// ./src/app/page/queues/queues.component.html